import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getVisitorId = () => {
  let vid = localStorage.getItem('proptick_vid');
  if (!vid) {
    vid = 'v_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem('proptick_vid', vid);
  }
  return vid;
};

// Batch queue for events
let eventQueue = [];
let flushTimer = null;

const flushEvents = () => {
  if (eventQueue.length === 0) return;
  const batch = [...eventQueue];
  eventQueue = [];
  flushTimer = null;
  
  axios.post(`${API}/events/track-batch`, {
    events: batch,
    visitor_id: getVisitorId(),
    user_agent: navigator.userAgent
  }).catch(() => {});
};

export const trackEvent = (eventType, listingId = null, page = null) => {
  eventQueue.push({ event_type: eventType, listing_id: listingId, page: page });
  
  // Flush after 500ms of inactivity (batches rapid-fire events)
  if (flushTimer) clearTimeout(flushTimer);
  flushTimer = setTimeout(flushEvents, 500);
};
